import styles from './IconGridModule.module.scss';

import React, { ReactHTML } from 'react';

import { CardLayoutType } from 'api/contentful/contentTypes.cloverdotcom';
import { Grid } from 'components/Grid/Grid';
import { TextV2 } from 'components/TextV2/TextV2';
import type { AppType, WithCMS } from 'services/cms/typesUtil';
import { IconCarouselLayout } from './IconCarouselLayout/IconCarouselLayout';
import { IconGridLayout } from './IconGridLayout/IconGridLayout';
import { ICON_GRID_MODULE_TEST_ID } from './IconGridModule.const';

type IconGridModuleProps = AppType.Component<{
  headline: string;
  body: string;
  items: Array<WithCMS<AppType.Content>>;
  iconLayoutStyle: string;
  themeStyle: string;
  headingTagName: keyof ReactHTML;
}>;

export const IconGridModule: React.FC<IconGridModuleProps> = ({
  headline,
  body,
  items,
  iconLayoutStyle,
  themeStyle,
  headingTagName = 'h2',
  ...props
}) => {
  const renderLayout = () =>
    iconLayoutStyle === CardLayoutType.GRID ? (
      <IconGridLayout items={items} />
    ) : (
      <IconCarouselLayout items={items} />
    );

  return (
    <section {...props._attributes} data-theme={themeStyle}>
      <Grid container className={styles.iconGrid} justifyContent="center">
        <Grid item lg={10} md={9} sm={12} className={styles.iconGridTitleContainer}>
          {headline && (
            <TextV2
              value={headline}
              variant="h2-medium"
              tagName={headingTagName}
              className={styles.iconGridHeadline}
              data-testid={ICON_GRID_MODULE_TEST_ID.headline}
            />
          )}
          {body && (
            <TextV2
              value={body}
              variant="body"
              tagName="p"
              className={styles.iconGridDescription}
              data-testid={ICON_GRID_MODULE_TEST_ID.body}
            />
          )}
        </Grid>
        {items && renderLayout()}
      </Grid>
    </section>
  );
};
